<template>
  <ClientOnly>
    <TransitionRoot appear :show="systemDialogStore.isOpen" as="template">
      <Dialog
        as="div"
        :open="systemDialogStore.isOpen"
        class="relative z-[999]"
        @close="closeSystemDialog"
      >
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black bg-opacity-50" />
        </TransitionChild>

        <div
          class="fixed inset-0 flex h-full w-full items-center justify-center p-4"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="max-h-full w-[565px] bg-primary border border-white py-20 px-4 shadow-xl transition-all relative"
            >
              <UiButton
                variant="clear"
                variant-type="icon"
                class="absolute right-3 top-3 size-5"
                :aria-label="
                  $t('ariaLabelClose', {
                    title: $t('systemDialogStore.dialogState.title'),
                  })
                "
                @click="closeSystemDialog"
              >
                <UiIcon name="close-thin" class="size-5 text-white" />
              </UiButton>
              <div class="max-w-[380px] mx-auto">
                <div class="ui-h1 text-white uppercase text-center mb-2">
                  {{ systemDialogStore.dialogState.title }}
                </div>
                <div class="ui-text-m text-white text-center mb-4">
                  {{ systemDialogStore.dialogState.text }}
                </div>
                <div class="flex justify-center gap-3">
                  <UiButton
                    v-if="isConfirm"
                    variant="outlined"
                    color="white"
                    @click="cancel"
                  >
                    {{ systemDialogStore.dialogState?.cancelBtnText }}
                  </UiButton>
                  <UiButton color="white" @click="success">
                    {{ systemDialogStore.dialogState?.successBtnText }}
                  </UiButton>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </ClientOnly>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import { useSystemDialogStore } from "~/stores/systemDialog";
const systemDialogStore = useSystemDialogStore();

watch(
  () => systemDialogStore.isOpen,
  () => {
    if (systemDialogStore.isOpen) {
      (document.activeElement as HTMLElement)?.blur?.();
    }
  },
);

const { cancel, success, isConfirm, closeSystemDialog } = useSystemDialogs();
</script>
